import { render, staticRenderFns } from "./SystemActivity.vue?vue&type=template&id=1993d568"
import script from "./SystemActivity.vue?vue&type=script&lang=js"
export * from "./SystemActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports